// extracted by mini-css-extract-plugin
module.exports = {"pqDisclaimerText":"Disclaimer_pqDisclaimerText__1FVcu"};